export const aciSleep = {
    iconName: 'sleep',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M4 11.333v-2A1.333 1.333 0 015.333 8h5.334A1.333 1.333 0 0112 9.333v2M12 11.333v-2A1.334 1.334 0 0113.333 8h5.334A1.333 1.333 0 0120 9.333v2M3.778 11.333h16.444A1.778 1.778 0 0122 13.111v4.222H2v-4.222a1.778 1.778 0 011.778-1.778v0zM2 17.333V20M22 17.333V20',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M20 11.333v-6A1.334 1.334 0 0018.667 4H5.333A1.333 1.333 0 004 5.333v6',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
